export default __webpack_public_path__ + "static/media/1061.ebec7a85.png";